import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import styled from "styled-components";
import { useReviewDetail, useReviewResultDetail } from "../../../api/review/hooks";
import ReviewResult from "../../organisms/ReviewResult";
import { showAlert } from "../../../reducer/alertSlice";

/**
 * 받은 리뷰 결과 상세
 * - 일반 사용자용 화면
 */
const ReviewResultDetail = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const pathname = useLocation().pathname;
    let splitPathname = pathname.split("/");
    const reviewIdx = splitPathname[splitPathname.length - 1];

    const { data: reviewResultData, isLoading: isReviewResultDetailLoading, isError, error,  refetch } = useReviewResultDetail(reviewIdx);

    useEffect(() => {
        if (isError && error.response?.data?.code === -4) {
            dispatch(showAlert({
                msg: "잘못된 접근입니다.",
                func: () => {
                    navigate(-1)
                }
            }));
        }
    }, [dispatch, isError])

    useEffect(() => {
        if (reviewResultData?.data) {
            console.log("@@reviewResultData:", reviewResultData?.data?.question);
        }
    }, [reviewResultData]);

    return (
        <>
            {reviewResultData && (
                <>
                    <Wrap>
                        <div className="review-form">
                            <ReviewResult reviewDetailData={reviewResultData?.data} reviewResultData={reviewResultData?.data?.question} />
                        </div>
                    </Wrap>
                </>
            )}
        </>
    );
};

const Wrap = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: flex-start;
    gap: 50px;

    .review-form {
        display: flex;
        flex-direction: column;
        width: 800px;
    }
`;

export default ReviewResultDetail;